import styled from 'styled-components';

export const Content = styled.div`
  flex: 1;
  margin-top: 20px;
  overflow-y: auto;
  padding-right: 4px;
`;
